import React, { useState } from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import { useForm } from 'react-hook-form';
import { Link } from 'gatsby-theme-material-ui';
import { TickSuccessIcon } from '../../../kit/icons/TickSuccessIcon';
import { sendYandexMetrikaEvent } from '../../../helpers/yandexMetrika';
import {
  getRoistatFromCookie,
  getUtmFromCookie,
} from '../../../helpers/utmCookie';
import { EMAIL_REGEX } from './tools';
import styles from './styles';
import { apiMyLead } from '../../../app/constants/urls';
import { sendLeadData } from '../../../helpers/amoLead';

const errorText = 'Что-то пошло не так';

export default function FooterSubscription() {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const handleSubscribeClick = async (data) => {
    let clientId = '';

    try {
      /*eslint-disable */
      clientId = ga && ga.getAll()[0].get('clientId');
      /* eslint-enable */
    } catch (e) {}

    try {
      setIsError(false);
      setIsLoading(true);
      await sendLeadData(data, {
        pipelineType: 'subscribeNew',
        leadAction: 'Подписка новости',
        leadBlock: 'Футер',
      });
      // await fetch( apiMyLead, {
      //   method: 'POST',
      //   headers: {
      //     'Content-Type': 'application/json',
      //   },
      //   body: JSON.stringify({
      //     ...data,
      //     pipelineType: 'subscribeNew',
      //     clientId,
      //     program: 'JS',
      //     utm: getUtmFromCookie(),
      //     roistatVisit: getRoistatFromCookie(),
      //     leadAction: 'Подписка новости',
      //     leadBlock: 'Футер',
      //   }),
      // });

      sendYandexMetrikaEvent('emailSign');
      setIsSubscribed(true);
    } catch (error) {
      setIsError(true);
      console.error(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {!isSubscribed && (
        <Box sx={{ width: '100%' }}>
          <Typography variant="mobileP2" sx={styles.message}>
            Хочу получать интересные материалы
            <br />
            по программированию пару раз в месяц
          </Typography>
          <Box
            onSubmit={handleSubmit(handleSubscribeClick)}
            sx={styles.textFieldBlock}
            component="form"
          >
            <Box sx={styles.textFieldWrapper}>
              <TextField
                size="small"
                placeholder="Email"
                label="Email"
                sx={styles.input}
                color="secondary"
                helperText={
                  (isError && errorText) ||
                  (errors.email && errors.email.message)
                }
                {...register('email', {
                  required: 'Введите адрес почты',
                  pattern: {
                    value: EMAIL_REGEX,
                    message: 'Некорректно введенный email',
                  },
                })}
              />
            </Box>
            <Button
              variant="inverse"
              size="medium"
              sx={styles.submit}
              type="submit"
              disabled={isLoading}
            >
              Подписаться
            </Button>
          </Box>
          <Box>
            <Typography variant="mobileP2" sx={styles.agreement}>
              Продолжая, вы принимаете условия&nbsp;
              <Link
                href="https://elbrusboot.camp/privacy-policy/"
                variant="kitSecondaryInverseWhite"
                sx={{
                  fontSize: '14px',
                  lineHeight: '20px',
                  ml: { md: 0.5, sm: 0 },
                }}
                target="_blank"
              >
                Соглашения
              </Link>
            </Typography>
          </Box>
        </Box>
      )}
      {isSubscribed && (
        <Box>
          <Box sx={{ display: 'flex', flexDirection: 'column' }}>
            <Typography
              variant="desktopP3"
              color="kit.text.mainInverse"
              sx={styles.subscribedMessage}
            >
              Вы успешно подписались на рассылку!
            </Typography>
            <Button
              variant="inverse"
              size="large"
              disabled
              sx={styles.subscribed}
            >
              <TickSuccessIcon
                color="kit.text.mainInverse"
                sx={{ width: 12.67, height: 10 }}
              />
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
}
